/* global process */

import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'
import { FORT_BATTLE_RESULTS as FORT_BATTLE_RESULTS_URL } from 'urls'

export const FORT_BATTLE_RESULTS_REQUEST = 'fort_battle_results/REQUEST'
export const FORT_BATTLE_RESULTS_SUCCESS = 'fort_battle_results/SUCCESS'
export const FORT_BATTLE_RESULTS_ERROR = 'fort_battle_results/ERROR'
export const FORT_BATTLE_RESULTS_OPEN = 'fort_battle_results/OPEN'

export function startRequest() {
    return {
        type: FORT_BATTLE_RESULTS_REQUEST,
        payload: {},
    }
}

export function requestSuccess(results) {
    return {
        type: FORT_BATTLE_RESULTS_SUCCESS,
        payload: { results },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: FORT_BATTLE_RESULTS_ERROR,
        payload: errorData,
    }
}


export default function requestFortBattleResults(seriesId, clanId) {
    return async (dispatch, getState) => {
        if (getState().fortBattleResults.loading) {
            return
        }
        dispatch(startRequest())

        // Mock of postbattle data for development issues
        if (process.env.API_ENV === 'mock') {
            const mock = require('containers/PostbattleScreen/mock.js').default
            if (seriesId === 'dev') {
                return dispatch(requestSuccess(mock))
            }
        }

        const url = `/game_api/fort_battle_results/${seriesId}/${clanId}`
        httpRequest(url)
            .then(
                results => dispatch(requestSuccess(results)),
                errorData => dispatch(requestError(errorData))
            )
    }
}


export function openFortBattleResults(seriesId, clanId, title) {
    return (dispatch, getState) => {
        const state = getState()
        const { isInGameBrowser } = state.settings

        const urlParams = FORT_BATTLE_RESULTS_URL(seriesId, clanId)
        const url = `${window.location.protocol}//${window.location.host}/#${urlParams}`

        // Show in regular browser for dev and QA purposes
        if (!isInGameBrowser) {
            const newUrl = `${window.location.protocol}//${window.location.host}/postbattle.html#/${seriesId}/${clanId}`
            window.location.assign(newUrl)
        }

        return dispatch({
            type: FORT_BATTLE_RESULTS_OPEN,
            meta: {
                webToClient: {
                    handler: 'openBrowser',
                    params: {
                        url,
                        title,
                        width: 730,
                        height: 588, // also change in /backend/wgsh/battles/constants.py
                        isModal: false,
                        showCreateWaiting: false,
                    },
                },
            },
        })
    }
}



// WEBPACK FOOTER //
// ./state/actions/fort_battle_results.js